module.exports = __webpack_public_path__ + "img/0.6250e04b.png";